import React from 'react';
import { MessageInfo } from '@/api/types';

interface ContactMessageProps {
  message: MessageInfo;
  isOwnMessage: boolean;
}

/**
 * 联系人卡片消息组件
 */
const ContactMessage: React.FC<ContactMessageProps> = ({ message, isOwnMessage }) => {
  const contactInfo = message.decryptedContentData?.attachment?.contactInfo;

  if (!contactInfo) {
    return (
      <div className={`px-4 py-2 rounded-2xl ${isOwnMessage
          ? 'bg-red-500 text-white rounded-br-md'
          : 'bg-red-100 text-red-900 rounded-bl-md'
        }`}>
        <p className="text-sm">联系人信息加载失败</p>
      </div>
    );
  }

  return (
    <div className={`rounded-2xl overflow-hidden max-w-xs ${isOwnMessage ? 'rounded-br-md' : 'rounded-bl-md'
      }`}>
      <div className={`p-4 border ${isOwnMessage
          ? 'bg-blue-50 border-blue-200 text-gray-900'
          : 'bg-white border-gray-200 text-gray-900'
        }`}>
        <div className="flex items-center space-x-3">
          {/* 头像 */}
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center text-white font-semibold text-lg">
              {contactInfo.name ? contactInfo.name.charAt(0) : '👤'}
            </div>
          </div>

          {/* 联系人信息 */}
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold truncate">
              {contactInfo.name || '未知联系人'}
            </h3>
            {contactInfo.phone && (
              <p className="text-xs text-gray-500 truncate">
                {contactInfo.phone}
              </p>
            )}
          </div>

          {/* 卡片标识 */}
          <div className="flex-shrink-0">
            <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z" clipRule="evenodd" />
            </svg>
          </div>
        </div>

        {/* 操作按钮 */}
        <div className="mt-3 pt-3 border-t border-gray-100">
          <button className="w-full text-center text-xs text-blue-600 hover:text-blue-800 font-medium py-1">
            查看联系人
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactMessage;
